import React, { useState, useEffect } from "react";
import "../css/components.css";

type CardTilesProps = {
  id: Number | string;
  text: String;
  isActive: Boolean;
  setIsActive: Function;
  getIdData: boolean;
};

function CardTiles({
  id,
  text,
  isActive,
  setIsActive,
  getIdData,
}: CardTilesProps) {
  return (
    <div>
      <button
        onClick={(e) => {
          setIsActive(getIdData ? id : text);
        }}
        className={isActive ? "card_tile_active" : "card_tile_inactive"}
      >
        {text}
      </button>
    </div>
  );
}

export default CardTiles;
